import { render, staticRenderFns } from "./shift-import-clipboard.vue?vue&type=template&id=c28799e8&scoped=true&"
import script from "./shift-import-clipboard.vue?vue&type=script&lang=js&"
export * from "./shift-import-clipboard.vue?vue&type=script&lang=js&"
import style0 from "./shift-import-clipboard.vue?vue&type=style&index=0&id=c28799e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28799e8",
  null
  
)

export default component.exports